import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import CounterTotalSection from '../../../shared/components/CounterTotalSection';
import Paragraph from '../../../shared/components/Paragraph';
import Section from '../../../shared/components/Section';
import TrustVoiceSection from '../../../shared/components/TrustVoiceSection';
import SubscribeShareSection from '../../../shared/components/SubscribeShareSection';

export default function ThankYouContainer() {
  const { t } = useTranslation();

  return (
    <>
      <Section
        background="blue"
        title={t('thx_heading')}
      />

      <CounterTotalSection totalKey="TotalVotedForConsitutionInBY" title={t('thx_thankyou')} />

      <Section
        align="center"
        background="gray"
        content={(
          <>
            <Paragraph
              variant="body2"
              textAlign="center"
            >
              <Trans
                i18nKey="thx_p_1"
                components={{ bold: <strong /> }}
              />
            </Paragraph>
            <Paragraph
              variant="body2"
              textAlign="center"
            >
              {t('thx_p_2')}
            </Paragraph>
          </>
        )}
      />

      <SubscribeShareSection shareUrl="https://golos2020.org/constitution" />

      <TrustVoiceSection />
    </>
  );
}
